import React from "react";

const OrderConfirmationMessage = ({ name }) => {
  return (
    <div>
      <h1>Order Confirmation</h1>
      <p>Thank you for your order, {name}!</p>
    </div>
  );
};

export default OrderConfirmationMessage;
